import { BaseDto } from './base.dto';
import { CustomerDto } from './customer.dto';
import { MerchantDto } from './merchant.dto';
import { PosDeviceDto } from './posDevice.dto';

export class OrderNoteOptionDto extends BaseDto {
  merchantGroupId?: number;
  text?: string;
  enabled?: boolean;
  isTableNote?: boolean;
  isProductNote?: boolean;
  merchant?: MerchantDto;
  merchants?: MerchantDto[];
  selected?: Boolean;
  orderNoteOptionId?: number;
  sequence: number;
  customer?: CustomerDto; // UP-4434 - Should be on CartOrderNoteOption really! The problem is it seems we send orderNoteOption - not sure why
  posDeviceId?: number;
  posDevice?: PosDeviceDto;
  selectedBundleProductMenuModifierIndex?: number;
  selectedBundleMenuCategoryProductModifierIndex?: number;
  selectedBundleMenuCategoryIndex?: number;
  enabledForThisMerchant?: boolean;
  clickedSequence?: number;
}
 